import { CSSProperties, MutableRefObject, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import { v4 as uuidv4 } from "uuid";
import { ButtonSizeTypes } from "@enums/button-size-types";
import { ButtonTypes } from "@enums/button-types";
import { addLoadingIndicator, removeLoadingIndicator } from "@redux/actions/loading-indicators-actions";
import styles from "./button-with-spinner.less";

type ButotnWithSpinnerProps = {
    buttonRef?: MutableRefObject<HTMLButtonElement>;
    id?: string;
    type: ButtonTypes;
    disabled: boolean;
    variant: string;
    label: string;
    buttonSize?: ButtonSizeTypes;
    hideSpinner?: boolean;
    className?: string;
    style?: CSSProperties
    automationId?: string;
    onClick?: () => void;
};

export const ButtonWithSpinner = (props: ButotnWithSpinnerProps) => {
    const {
        buttonRef,
        id,
        className,
        type,
        variant,
        disabled,
        label,
        style,
        hideSpinner,
        automationId,
        buttonSize,
        onClick
    } = props;

    const [uuidString, setUuidString] = useState(null);
    const dispatch = useDispatch();

    useEffect(() => {
        if (disabled && !hideSpinner) {
            const uuid = uuidv4();
            setUuidString(uuid);
        } else {
            setUuidString(null);
        }
    }, [disabled, hideSpinner]);

    useEffect(() => {
        if (uuidString) {
            dispatch(addLoadingIndicator(uuidString));
        }

        return () => {
            if (uuidString) {
                setTimeout(() => {
                    // delay the execution of this function by 300 ms
                    dispatch(removeLoadingIndicator(uuidString));
                }, 300);
            }
        }
    }, [uuidString]);

    return (
        <Button
            ref={buttonRef}
            id={id}
            automation-id={automationId}
            size={buttonSize}
            type={type}
            variant={variant}
            disabled={disabled}
            style={style}
            className={classNames(styles.buttonWithSpinner, className)}
            onClick={onClick}
        >
            {label}
            <Spinner
                className={styles.spinner}
                as="span"
                animation="border"
                size="sm"
                role="status"
                aria-hidden="true"
                hidden={!disabled || hideSpinner}
            />
        </Button>
    );
};